import Point from './point';

class BoundingBox {
	x = 0;

	y = 0;

	width = 0;

	height = 0;

	bottom = 0;

	top = 0;

	right = 0;

	left = 0;

	center = null;

	constructor(x, y, width, height) {
		this.x = x;
		this.y = y;
		this.left = x;
		this.top = y;

		this.width = width;
		this.height = height;

		this.right = x + width;
		this.bottom = y + height;

		this.center = this.getCenter();
	}

	static fromMinMax(options) {
		const { minPoint, maxPoint, minX, minY, maxX, maxY } = options;

		if (minPoint instanceof Point && maxPoint instanceof Point) {
			return new BoundingBox(minPoint.x, minPoint.y, maxPoint.x - minPoint.x, maxPoint.y - minPoint.y);
		}
		if (typeof minX === 'number' && typeof minY === 'number' && typeof maxX === 'number' && typeof maxY === 'number') {
			return new BoundingBox(minX, minY, maxX - minX, maxY - minY);
		}

		throw new Error(`Invalid Bounding MinMax Options ${options}`);
	}

	static fromPoints(points) {
		if (points && points.length === 0) {
			throw new Error(`Invalid Bounding Box Points ${points}`);
		}

		let minX = points[0].x;
		let maxX = points[0].x;
		let minY = points[0].y;
		let maxY = points[0].y;

		points.forEach((point) => {
			if (point.x < minX) {
				minX = point.x;
			} else if (point.x > maxX) {
				maxX = point.x;
			}

			if (point.y < minY) {
				minY = point.y;
			} else if (point.y > maxY) {
				maxY = point.y;
			}
		});

		return BoundingBox.fromMinMax({ minX, minY, maxX, maxY });
	}

	overlapsWith(boundingBox, inclusive = false) {
		if (inclusive) {
			return (
				this.left <= boundingBox.right &&
				this.right >= boundingBox.left &&
				this.top <= boundingBox.bottom &&
				this.bottom >= boundingBox.top
			);
		}

		return (
			this.left < boundingBox.right &&
			this.right > boundingBox.left &&
			this.top < boundingBox.bottom &&
			this.bottom > boundingBox.top
		);
	}

	getIntersectionBox(boundingBox, inclusive = false) {
		if (!this.overlapsWith(boundingBox, inclusive)) {
			return null;
		}

		const minX = Math.max(this.left, boundingBox.left);
		const minY = Math.max(this.top, boundingBox.top);
		const maxX = Math.min(this.right, boundingBox.right);
		const maxY = Math.min(this.bottom, boundingBox.bottom);

		return BoundingBox.fromMinMax({ minX, minY, maxX, maxY });
	}

	getCenter() {
		return new Point(this.x + this.width / 2, this.y + this.height / 2);
	}

	containsPoint(point, inclusive = false) {
		if (inclusive) {
			return point.x >= this.left && point.x <= this.right && point.y >= this.top && point.y <= this.bottom;
		}

		return point.x > this.left && point.x < this.right && point.y > this.top && point.y < this.bottom;
	}
}

export default BoundingBox;
